import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocationDto, LowStockProduct } from '../../inventory/inventory.model';
import { InventoryService } from '../../inventory/inventory.service';

@Component({
  selector: 'app-low-stock-products',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './low-stock-products.component.html',
  styleUrl: './low-stock-products.component.scss',
})
export class LowStockProductsComponent implements OnInit {
  private inventoryService = inject(InventoryService);

  locations: LocationDto[] = [];
  selectedLocationId = '';
  lowStockProducts: LowStockProduct[] = [];

  ngOnInit() {
    this.loadLocations();
  }

  loadLocations() {
    this.inventoryService.getAllLocations().subscribe((res) => {
      this.locations = res;
    });
  }

  loadLowStock() {
    if (!this.selectedLocationId) return;
    this.inventoryService.getLowStockProducts(this.selectedLocationId).subscribe((res) => {
      this.lowStockProducts = res;
    });
  }

  requestRestock(productId: string, quantity: number) {
    if (!this.selectedLocationId) return;

    const payload = {
      productId,
      locationId: this.selectedLocationId,
      quantityRequested:quantity,
    };

    this.inventoryService.createReorderRequest(payload).subscribe(() => {
      alert('Reorder request submitted');
    });
  }
}
